import { fetchAuthSession } from 'aws-amplify/auth';

export const API_BASE_URL = (
  process.env.REACT_APP_API_BASE_URL ||
  'https://wxmyuvmttrdtag5vl73nnqyx4m0zhlvq.lambda-url.eu-west-2.on.aws'
).replace(/\/$/, '');

// The backend verifies this Cognito ID token and works out who the user is from it.
const authHeader = async () => {
  const { tokens } = await fetchAuthSession();
  const idToken = tokens?.idToken?.toString();
  if (!idToken) throw new Error('You need to be signed in to do this.');
  return { Authorization: `Bearer ${idToken}` };
};

const request = async (path, { auth = false, method = 'GET', body } = {}) => {
  const headers = {
    ...(body ? { 'Content-Type': 'application/json' } : {}),
    ...(auth ? await authHeader() : {}),
  };
  const response = await fetch(`${API_BASE_URL}${path}`, {
    method,
    headers,
    body: body ? JSON.stringify(body) : undefined,
  });

  if (!response.ok) {
    const error = await response.json().catch(() => ({ detail: 'Network error' }));
    throw new Error(error.detail || `Request failed (${response.status})`);
  }
  return response.json();
};

// Signup (no account yet, so no token).
export const checkNewCompanyName = (newCompanyName) =>
  request('/signup-check', { method: 'POST', body: { new_company_name: newCompanyName } });

export const lookupInvite = (token) =>
  request('/invites/lookup', { method: 'POST', body: { token } });

// Team and invites (signed in; inviting and revoking are company-admin only).
export const getTeam = () => request('/team', { auth: true });

export const createInvite = (email) =>
  request('/invites', { auth: true, method: 'POST', body: { email } });

export const revokeInvite = (inviteId) =>
  request(`/invites/${encodeURIComponent(inviteId)}`, { auth: true, method: 'DELETE' });

// Uploads: the backend picks the S3 location from the signed-in user's company.
export const getUploadUrl = (fileName) =>
  request('/upload-url', { auth: true, method: 'POST', body: { file_name: fileName } });

// Chat: the backend searches only the signed-in user's company's documents.
export const submitQuery = (queryText) =>
  request('/submit_query', { auth: true, method: 'POST', body: { query_text: queryText } });

// Admin page.
export const getAdminData = async () => (await request('/admin/data', { auth: true })).items;
